import { Instance } from '@empathybroker/tsclient-play/dist/models/instance/instance';
import { PermissionConfig } from '@empathybroker/tsclient-play/dist/models/instance/permission-config';

import { CONTAINER, TYPES } from '../config';

import { FeatureIdEnum, PermissionLevelEnum, RoleEnum } from '../enums';

import { Authorization, FeatureNode, FeaturesTree } from '../models';

export class FeaturesTreeUtils {

  public static getFeaturesTree(instanceConfig: Instance, authorization: Authorization): FeaturesTree {
    if (!instanceConfig) {
      return { common: [] };
    }
    const featuresTree = { ...CONTAINER.get<FeaturesTree>(TYPES.FeaturesTree) };
    const userRolesWithRepeatedValues = (authorization['*'] || []).concat(authorization[instanceConfig.instanceId] || []);
    const userRoles = (Array.from(new Set(userRolesWithRepeatedValues).values()) as RoleEnum[]);
    Object.entries(featuresTree).forEach(([domain, domainFeatureNodes]) => {
      const domainPermissionConfigs = instanceConfig.permissions[domain];
      if (!!domainPermissionConfigs) {
        featuresTree[domain] = FeaturesTreeUtils.filterFeatureNodes(domainFeatureNodes, domainPermissionConfigs, userRoles);
      } else {
        delete featuresTree[domain];
      }
    });
    return featuresTree;
  }

  public static getFeatureNode(featureId: (FeatureIdEnum | string), featureNodes: FeatureNode[] = []): FeatureNode {
    for (const featureNode of featureNodes) {
      if (featureNode.id === featureId) {
        return featureNode;
      } else if (!!featureNode.children) {
        const childFeatureNode = FeaturesTreeUtils.getFeatureNode(featureId, featureNode.children);
        if (!!childFeatureNode) {
          return childFeatureNode;
        }
      }
    }
  }

  private static filterFeatureNodes(featureNodes: FeatureNode[], permissionConfigs: PermissionConfig[], userRoles: RoleEnum[],
    parentFeatureIds: (FeatureIdEnum | string)[] = [], parentFeatureRoles?: RoleEnum[]): FeatureNode[] {
    return featureNodes.reduce((filteredFeatureNodes: FeatureNode[], featureNode: FeatureNode) => {
      const featureIds = parentFeatureIds.concat(featureNode.id);
      const featureRoles = (featureNode.roles || parentFeatureRoles);
      if (!!featureNode.children) {
        featureNode = {
          ...featureNode,
          children: FeaturesTreeUtils.filterFeatureNodes(featureNode.children, permissionConfigs, userRoles, featureIds, featureRoles)
        };
      }
      const featurePermissionLevel = FeaturesTreeUtils.getFeaturePermissionLevel(featureIds, featureRoles, permissionConfigs, userRoles);
      if ((!!featureNode.children && !!featureNode.children.length) || (featurePermissionLevel !== PermissionLevelEnum.NONE)) {
        filteredFeatureNodes.push({
          ...featureNode,
          permissionLevel: featurePermissionLevel
        });
      }
      return filteredFeatureNodes;
    }, []);
  }

  private static getFeaturePermissionLevel(featureIds: (FeatureIdEnum | string)[], featureRoles: RoleEnum[],
    permissionConfigs: PermissionConfig[], userRoles: RoleEnum[]): PermissionLevelEnum {
    if (featureIds.includes(FeatureIdEnum.ACCOUNT)) {
      return PermissionLevelEnum.WRITE;
    }
    if (!featureRoles || userRoles.some((userRole: RoleEnum) => featureRoles.includes(userRole))) {
      const featurePermissionConfigs = permissionConfigs.filter((permissionConfig: PermissionConfig) =>
        featureIds.includes(permissionConfig.id));
      for (const permissionLevel of Object.values(PermissionLevelEnum)) {
        if (featurePermissionConfigs.some((permissionConfig: PermissionConfig) => (permissionConfig.level === permissionLevel))) {
          return permissionLevel;
        }
      }
    }
    return PermissionLevelEnum.NONE;
  }

}
